const TasksRouteNavigationOptions = {
  title: 'Tasks',
  headerTitle: () => null,
  headerBackVisible: false,
};

export default TasksRouteNavigationOptions;
